import React from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';
import { ROUTES } from 'shared/routes/constants';
import SurveyClosedUI from 'uicontainers/apps/survey/SurveyClosed';
import SurveyClosedRefreshUI from 'uicontainers/apps/survey_refresh/SurveyClosed';

export const SurveyClosed = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const template = queryParams.get('survey_template');
  return (
    <>
      <Switch>
        <Route
          path={ROUTES.SURVEY.PATHS.SURVEY_CLOSED}
          component={template === 'SURVEY_2025' ? SurveyClosedRefreshUI : SurveyClosedUI}
        />
      </Switch>
    </>
  );
};

export default SurveyClosed;
